import React, { memo } from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { Icon, ICONS } from "./Icons";

const Wrapper = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  columnGap: "8px",
  fontSize: "12px",
  fontWeight: "normal",
  lineHeight: "16px",
  color: "var(--Color-Text-Secondary-On-Light)",
  marginTop: "10px",
  ".formControl &": {
    marginTop: "10px"
  },
  "& div": {
    display: "flex",
    alignItems: "center"
  }
});

const IconStyled = styled(Icon)({
  width: "14px",
  height: "14px",
  flexShrink: 0
});

const InfoTitleBase = ({ title, iconName = ICONS.info, ...props }) => {
  return (
    <Wrapper {...props}>
      <IconStyled name={iconName} />
      <div>{title}</div>
    </Wrapper>
  );
};

InfoTitleBase.propTypes = {
  title: PropTypes.node.isRequired,
  iconName: PropTypes.string
};

export const InfoTitle = memo(InfoTitleBase);
